import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'others.contact.utils',
  },
  phone: {
    id: 'others.contact.utils.phone.call',
  },
  NumUrgences: {
    id: 'Contactsutils.NumUrgences.title',
  },
  NumUrgencesYakada: {
    id: 'Contactsutils.NumUrgencesYakada',
  },
  NumUrgencesSamu: {
    id: 'Contactsutils.NumUrgencesSamu',
  },
  NumUrgences300: {
    id: 'Contactsutils.NumUrgences300',
  },
  numeros_assistance: { id: 'Contactsutils.numeros_assistance' },
  numeros_secours: { id: 'Contactsutils.numeros_secours' },
  adresses_utiles: { id: 'Contactsutils.adresses_utiles' },
});
